import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const TriangulationNavUI = ({ context, account, page }) =>
  <div className='g_flex_h g_flex_left g_flex_wrap nav'>
    <TabLinkUI label='Data' to={`/su/accounts/${account.accountId}/triangulations`} active={page === 'data'} />
    <TabLinkUI label='Charts' to={`/su/accounts/${account.accountId}/triangulations/charts`} active={page === 'charts'} />
  </div>

export default TriangulationNavUI
